import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductPageContext } from "../context/ProductPageContext"

export const ProductPageConfigureButton = React.memo(() => {
  const { t } = useTranslation()
  const { onConfigure } = useProductPageContext()

  return (
    <Button
      id="product-page__configuration-button"
      variant={ButtonVariant.SECONDARY}
      disabled={!onConfigure}
      onClick={onConfigure}
      icon={IconName.CONFIGURATION}
    >
      {t("Product.Configuration.Configure")}
    </Button>
  )
})
